import styled, { css } from 'styled-components'

import { ReactComponent as FolderIcon } from '@sketch/icons/folder-closed-17'
import { ReactComponent as DocumentIcon } from '@sketch/icons/document-17'

import {
  CARD_RADIUS,
  CARD_SHADOW,
  GLASS_BACKGROUND,
  GLASS_BLUR,
  NOTCH_CLIP_PATH,
} from './constants'

export const Card = styled.section(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: ${CARD_RADIUS};
    background: ${theme.colors.background.secondary.A};
    overflow: hidden;
    position: relative;

    box-shadow: ${CARD_SHADOW};
  `
)

export const BreadcrumbItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: ${({ theme }) => theme.fontSizes.D};
`

export const BreadcrumbLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Breadcrumb = styled.div(
  ({ theme }) => css`
    position: absolute;
    inset: 2px 2px auto;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: ${theme.colors.background.tertiary.D};
    color: ${theme.colors.foreground.secondary.B};
    font-size: 12px;
    font-weight: ${theme.fontWeights.medium};

    overflow: hidden;
    background-color: ${GLASS_BACKGROUND};
    backdrop-filter: blur(${GLASS_BLUR});
    border-radius: 18px 18px 8px 8px;
    z-index: 1;
    box-shadow: 0 1px 10px ${theme.colors.background.tertiary.B};

    ${BreadcrumbItem}:last-child {
      color: ${theme.colors.foreground.secondary.A};
    }
  `
)

export const BreadcrumbSeparator = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.D};
    opacity: 0.6;
  `
)

export const BreadcrumbFolderIcon = styled(FolderIcon)`
  width: 17px;
  height: 17px;
  flex-shrink: 0;
`

export const BreadcrumbDocumentIcon = styled(DocumentIcon)`
  width: 17px;
  height: 17px;
  flex-shrink: 0;
`

export const CanvasImage = styled.img(
  ({ theme }) => css`
    aspect-ratio: 16 / 9;
    width: 100%;
    object-fit: cover;
    display: block;
    background: ${theme.colors.background.canvas.A};
    position: relative;
  `
)

export const CanvasImageWrapper = styled.span`
  position: relative;
  overflow: hidden;

  ::before {
    content: '';
    inset: auto 0 0px;
    z-index: 1;
    height: 50px;
    position: absolute;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.06), transparent);
  }
`

export const AnnotationCard = styled.div`
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.background.secondary.A};
  margin-top: -15px;
  position: relative;

  /* Cap the embedded AnnotationCommentsList height so a long thread doesn't
   * stretch the preview indefinitely, while keeping enough room for the
   * comment box to feel usable. The list itself (first child) scrolls; the
   * reply input (last child) stays anchored at the bottom. */
  display: flex;
  flex-direction: column;
  max-height: calc(50vh - 50px);
  z-index: 1;

  > :first-child {
    flex: 1;
    min-height: 0;
  }

  ::after {
    content: '';
    inset: -11px 0 auto;
    margin: auto;
    position: absolute;
    height: 12px;
    width: 30px;
    background: ${({ theme }) => theme.colors.background.secondary.A};
    clip-path: ${NOTCH_CLIP_PATH};
  }
`
